import { useCallback } from 'react';

import { OverviewErrorKind } from './useOverviewErrorState';

interface Part {
  errorKind: OverviewErrorKind | null;
  retry: () => unknown;
}

/**
 * O mapa depende de duas rotas (pontos da variável e lista de variáveis). Falhando qualquer
 * uma, a parte "mapa" mostra o aviso; "Tentar novamente" refaz só a que falhou.
 */
export default function useOverviewMapError(mapData: Part, mapVariables: Part) {
  const {
    errorKind: dataError, retry: retryData,
  } = mapData;
  const {
    errorKind: variablesError, retry: retryVariables,
  } = mapVariables;

  const retry = useCallback(() => {
    if (dataError) retryData();
    if (variablesError) retryVariables();
  }, [dataError, retryData, variablesError, retryVariables]);

  return { errorKind: dataError ?? variablesError, retry };
}
